module.exports = require('./helpers/bundle-url').getBundleURL('hkxlb') + "black_panther.cb848b80.png";